import { CityLandingPage } from "../components/CityLandingPage";

export function WebdesignSchwarzheide() {
  return (
    <CityLandingPage city="Schwarzheide" citySlug="schwarzheide" variant="webdesign" />
  );
}
